import React from 'react';
import FeaturedImage from '../FeaturedImage';

function faculty(props) {
  const {
    post,
    postType,
    displayExcerpt,
    displayDate,
    displayCategories,

    replaceSelected,
    theExcerpt
  } = props;

  let categories;
  let role;
  let featuredImage;
  let date;

  if (post.hasOwnProperty('_embedded') && post._embedded.hasOwnProperty('wp:featuredmedia')) {
    featuredImage =
      <figure className="eight29-featured-image">
        <FeaturedImage
          imageSize={'faculty-index-featured'}
          image={post._embedded['wp:featuredmedia']}
          srcset={post.featured_image_srcset}
        ></FeaturedImage>
      </figure>
  }

  if (post.hasOwnProperty('_embedded') && post._embedded.hasOwnProperty('wp:term')) {
    categories = post._embedded['wp:term'][0];
  }

  if (post.excerpt && displayExcerpt) {
    excerpt = <div className="eight29-post-excerpt" dangerouslySetInnerHTML={{ __html: theExcerpt(post.excerpt.rendered) }}>
    </div>
  }

  if (displayDate) {
    date = <time>{post.formatted_date}</time>
  }

  if (post.id) {
    jQuery.ajax({
      url: '/wp-json/acf/v3/posts/' + post.id + '/roles', success: function (result) {
        if (result) {
          jQuery('[data-load-id="' + post.id + '"]').text(result.roles[0].role);
        }
      }
    });
  }

  return (
    <article id={`${postType}-${post.id}`} className="eight29-post eight29-post-card">
      <a href={post.link} className="eight29-post-wrapper">
        {featuredImage}

        <div className="eight29-post-body">
          <h4 className="eight29-post-title" dangerouslySetInnerHTML={{ __html: post.title.rendered }}></h4>

          <div className="eight29-post-role" data-load-id={post.id}>...</div>

          <div className="eight29-post-detail">
            {date}
          </div>
        </div>
      </a>
    </article>
  );
}

export default faculty;